export const routes = [
  {
    path: '/',
    name: 'Mentoring',
    component: () => import('./index.vue'),
    meta: {
      title: 'Наставничество',
      authorize: [],
    },
    children: [
      {
        path: 'list',
        name: 'MentorsList',
        component: () => import('./pages/MentorsList.vue'),
        meta: {
          title: 'Наставники и наставляемые',
          breadcrumbs: {
            parent: 'Mentoring',
          },
        },
      },
      {
        path: 'resources',
        name: 'MentorResources',
        component: () => import('./pages/MentorResources.vue'),
        meta: {
          title: 'Ресурсы',
          breadcrumbs: {
            parent: 'Mentoring',
          },
        },
      },
      {
        path: 'questionnaire',
        name: 'MentorQuestionnaire',
        component: () => import('./pages/MentorQuestionnaire.vue'),
        meta: {
          title: 'Анкеты',
          breadcrumbs: {
            parent: 'Mentoring',
          },
        },
      },
      {
        path: 'tags',
        name: 'PracticeTagList',
        component: () => import('@/modules/Tags/pages/TagList.vue'),
        meta: {
          title: 'Метки',
          breadcrumbs: {
            parent: 'Mentoring',
          },
          authorize: [],
          // help: 60,
        },
      },
    ],
  },
  {
    path: '/resources/:id',
    name: 'ResourceDetail',
    component: () => import('./pages/ResourseDetail.vue'),
    meta: {
      breadcrumbs: {
        parent: 'MentorResources',
      },
      layout: 'empty-layout',
      readonly: true,
    },
  },
  {
    path: '/resources/:id/edit',
    name: 'ResourceDetailEdit',
    component: () => import('./pages/ResourseDetail.vue'),
    meta: {
      breadcrumbs: {
        parent: 'MentorResources',
      },
      layout: 'empty-layout',
      readonly: false,
    },
  },
  {
    path: '/mentored-view/:id',
    name: 'MentoredView',
    component: () => import('./pages/MentoredView.vue'),
    meta: {
      title: 'Наставляемый',
      breadcrumbs: {
        parent: 'MentorsList',
      },
    },
  },
];

export default routes;
